var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.12274216 3.14913382 10.05196347 7.5230779 12.25390625 14.12890625 C13.3818169 28.8472157 13.3818169 28.8472157 8.25390625 35.12890625 C2.46956594 40.88996954 -1.16307542 43.27152712 -9.49609375 43.44140625 C-17.37420415 43.37649906 -20.57034795 41.8715958 -26.49609375 36.75390625 C-31.69798711 30.68503066 -32.34503759 25.39461341 -32.15625 17.61328125 C-31.46219315 11.71710306 -29.35696882 7.49983219 -24.9609375 3.5078125 C-17.79680873 -1.86148146 -8.51453049 -2.70091081 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(57.74609375,26.87109375)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.6875 0.75 1.6875 0.75 2.5 2.375 C2.6875 4.75 2.6875 4.75 0.5 7.9375 C-2.3125 10.75 -2.3125 10.75 -4.4375 11.8125 C-6.3125 11.75 -6.3125 11.75 -8.0625 10.3125 C-8.475 9.796875 -8.8875 9.28125 -9.3125 8.75 C-7.925165 4.2096309 -5.3700603 -0.58054706 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(75.3125,18.25)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.74200127 0 4.38139673 0.46672132 6.47265625 2.26953125 C7.875 3.8125 7.875 3.8125 10 7 C9.8125 9.375 9.8125 9.375 9 11 C7.375 11.8125 7.375 11.8125 5 12 C1.46048033 9.64032022 -0.51634262 8.29982922 -2 4.3125 C-2 2 -2 2 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(20,18)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.38249366 1.33909529 6.57949251 3.08994944 9 7 C8.75 9.3125 8.75 9.3125 8 11 C6.375 11.8125 6.375 11.8125 4 12 C0.9587018 9.91283457 -1.39242638 8.21514724 -3.0625 4.875 C-3 3 -3 3 -1.5625 1.25 C-1.046875 0.8375 -0.53125 0.425 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(69,66)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.6875 0.75 1.6875 0.75 2.5 2.375 C2.6875 4.75 2.6875 4.75 0.5 7.9375 C-2.3125 10.75 -2.3125 10.75 -4.4375 11.8125 C-6.3125 11.75 -6.3125 11.75 -8.0625 10.3125 C-8.475 9.796875 -8.8875 9.28125 -9.3125 8.75 C-7.925165 4.2096309 -5.3700603 -0.58054706 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(27.3125,66.25)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C13 4 13 4 12 6 C8.04 6 4.08 6 0 6 C-1 2 -1 2 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(76,45)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C13 4 13 4 12 6 C8.04 6 4.08 6 0 6 C-1 2 -1 2 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(8,45)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.96 0 7.92 0 12 C-4 13 -4 13 -6 12 C-6 8.04 -6 4.08 -6 0 C-4 -1 -4 -1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(51,76)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.96 0 7.92 0 12 C-4 13 -4 13 -6 12 C-6 8.04 -6 4.08 -6 0 C-4 -1 -4 -1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(51,8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.d824fb89801578530fc01da45887b0e3.svg";
export { ForwardRef as ReactComponent };